import * as React from 'react'
import { Grid, Paper } from '@mui/material'
import GridItem from 'src/components/grid-item/GridItem'
import { PersonReport } from 'src/modules/serasa/serasa.experian.person.types'
import { formatDateNoTz } from 'src/utils/formatter-utils'
import Consultas from './Consultas'
import Contatos from './Contatos'
import Endereco from './Endereco'
import Identificacao from './Identificacao'
import Ocupacao from './Ocupacao'
import ParticipacaoSocietaria from './ParticipacaoSocietaria'
import Pefin from './Pefin'
import Refin from './Refin'

export type SerasaExperianPFProps = {
    pfReport: PersonReport
}

export default function SerasaExperianPF({ pfReport }: SerasaExperianPFProps) {
    if (!pfReport || !pfReport.reports || !pfReport.reports.length) {
        return (
            <Paper elevation={3} style={{ padding: 10 }}>
                Nenhum dado encontrado
            </Paper>
        )
    }
    return (
        <>
            {pfReport.reports.map((person, index) => (
                <Paper key={index} elevation={3} style={{ padding: 10 }}>
                    <Grid container spacing={1} paddingTop={2} paddingBottom={2} paddingLeft={5} paddingRight={5}>
                        <GridItem label="Tipo Relatório" value={person.reportName} xs={12} />
                        <GridItem
                            label="Data da Atualização"
                            value={
                                person.registration.statusDate ? formatDateNoTz(person.registration.statusDate) : '-'
                            }
                            xs={12}
                        />
                        <GridItem label="CPF" value={person.registration.documentNumber || '-'} xs={12} />
                    </Grid>

                    <Identificacao person={person} />
                    <Endereco person={person} />
                    <Contatos person={person} />
                    <Ocupacao person={person} />
                    <ParticipacaoSocietaria participacoes={person.partner?.partnershipResponse} />
                    <Pefin pefin={person.negativeData?.pefin} />
                    <Refin refin={person.negativeData?.refin} />
                    <Consultas summary={person.facts?.inquirySummary} inquiry={person.facts?.inquiry} />
                </Paper>
            ))}
        </>
    )
}
